import { store } from 'react-notifications-component';
import 'animate.css/animate.min.css';

let _defaultProps;

class Notification {

    constructor() {
        _defaultProps= {
            insert: "top",
            container: "bottom-center",
            animationIn: ["animate__animated", "animate__bounceIn"],
            animationOut: ["animate__animated", "animate__bounceOut"],
            dismiss: {
                duration: 5000,
            },
        }
    }

    _addNotification = (type, message, title = "", {..._otherProps} = {}) => {
        store.addNotification({
            type,
            title,
            message,
            ..._defaultProps,
            ..._otherProps,
        });
    }

    static success = (message, title, {..._otherProps} = {}) => {
        let _notification=new Notification();
        _notification._addNotification("success", message, title, _otherProps);
    }

    static danger = (message, title, {..._otherProps} = {}) => {
        let _notification=new Notification();
        _notification._addNotification("danger", message, title, _otherProps);
    }

    static info = (message, title, {..._otherProps} = {}) => {
        let _notification=new Notification();
        _notification._addNotification("info", message, title, _otherProps);
    }

    static warning = (message, title, {..._otherProps} = {}) => {
        let _notification=new Notification();
        _notification._addNotification("warning", message, title, _otherProps);
    }

    static default = (message, title, {..._otherProps} = {}) => {
        let _notification=new Notification();
        _notification._addNotification("default", message, title, _otherProps);
    }
}

export default Notification;
